// extracted by mini-css-extract-plugin
export default {"DateRangeBoxField":"GlobalStatsExport_DateRangeBoxField__OOV0S"};